module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_1@3x.0706e5bd.png";